import 'antd/dist/antd.css';
import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styled from 'styled-components';

import { LandingMain, LandingFooter, LandingHeader } from './components';
import { AuthPage, GeneratorPage } from './generator';
import Providers from './Providers';
import GlobalStyle from './GlobalStyle';
import PrivateRoute from './PrivateRoute';

const antIcon = <LoadingOutlined style={{ fontSize: 72 }} spin />;

class Wrapper extends React.Component {
  public render() {
    return (
      <Providers>
        <GlobalStyle />
        <Router>
          <App />
        </Router>
      </Providers>
    );
  }
}

function App() {
  return (
    <Suspense
      fallback={
        <LoaderWrapper>
          <Spin indicator={antIcon} />
        </LoaderWrapper>
      }
    >
      <Switch>
        <PrivateRoute exact path="/app">
          <GeneratorPage />
        </PrivateRoute>
        <Route exact path="/auth">
          <AuthPage />
        </Route>
        <Route exact path="/">
          <LandingHeader />
          <LandingMain />
          <LandingFooter />
        </Route>
      </Switch>
    </Suspense>
  );
}

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

export default Wrapper;
